import { render } from "./CategoryCard.vue?vue&type=template&id=46297c89&scoped=true"
import script from "./CategoryCard.vue?vue&type=script&lang=js"
export * from "./CategoryCard.vue?vue&type=script&lang=js"

import "./CategoryCard.vue?vue&type=style&index=0&id=46297c89&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46297c89"]])

export default __exports__